<div *ngIf="isLoading == false">
  <div class="row">
    <div class="col text-center" *ngIf="dupes.length > 0">
      <div class="alert alert-primary" role="alert">
        <small> Similar records detected. Are those one person? </small>
      </div>
    </div>
  </div>
  <div *ngFor="let dupe of dupes; let index = index">
    <div class="row" *ngIf="dupe['resolved'] == false">
      <div
        class="text-center"
        [class.col-9]="dupe['answer'] == 1"
        [class.col]="dupe['answer'] == 0 || dupe['answer'] == 2"
      >
        <span>
          {{ dupe.member1.firstName }} {{ dupe.member1.lastName }} <br />
          {{
            _formatService.GetShortFormatedDate(
              dupe.member1.dateOfBirth,
              globalService.isRTL
            )
          }}</span
        >
      </div>
      <div [class.col-3]="dupe['answer'] == 1" *ngIf="dupe['answer'] == 1">
        <button
          class="btn btn-secondary btn-block"
          [class.btn-secondary]="
            dupe['answer'] == 1 &&
            (dupe['selection'] == 0 || dupe['selection'] == 2)
          "
          [class.btn-primary]="dupe['answer'] == 1 && dupe['selection'] == 1"
          (click)="dupe['selection'] = 1"
          type="button"
        >
          <span><i class="fas fa-check"></i></span>
        </button>
      </div>
    </div>
    <br>
    <div class="row" *ngIf="dupe['resolved'] == false">
      <div
        class="text-center"
        [class.col-9]="dupe['answer'] == 1"
        [class.col]="dupe['answer'] == 0 || dupe['answer'] == 2"
      >
        <span>
          {{ dupe.member2.firstName }} {{ dupe.member2.lastName }} <br />
          {{
            _formatService.GetShortFormatedDate(
              dupe.member2.dateOfBirth,
              globalService.isRTL
            )
          }}</span
        >
      </div>
      <div [class.col-3]="dupe['answer'] == 1" *ngIf="dupe['answer'] == 1">
        <button
          class="btn btn-block"
          [class.btn-secondary]="
            dupe['answer'] == 1 &&
            (dupe['selection'] == 0 || dupe['selection'] == 1)
          "
          [class.btn-primary]="dupe['answer'] == 1 && dupe['selection'] == 2"
          (click)="dupe['selection'] = 2"
          type="button"
        >
          <span><i class="fas fa-check"></i></span>
        </button>
      </div>
    </div>
    <div *ngIf="dupe['resolved'] == false">
      <br />
    </div>
    <div
      class="row"
      *ngIf="dupe['answer'] == 0 && dupe['resolved'] == false"
    >
      <div class="col-6">
        <button class="btn btn-primary btn-block" (click)="dupe['answer'] = 1">
          Yes
        </button>
      </div>
      <div class="col-6">
        <button class="btn btn-primary btn-block" (click)="dupe['answer'] = 2">
          No
        </button>
      </div>
    </div>
    <div
      class="row"
      *ngIf="dupe['answer'] == 1 && dupe['resolved'] == false"
    >
      <div class="col-12">
        <div class="alert alert-secondary text-center" role="alert">
          <small>Choose which record to keep then click Merge. </small>
        </div>
      </div>
    </div>
    <div
      class="row"
      *ngIf="dupe['answer'] == 1 && dupe['resolved'] == false"
    >
      <div class="col-6">
        <button
          class="btn btn-success btn-block"
          (click)="Merge(index, dupe['selection'])"
          [disabled]="dupe['selection'] == 0"
        >
          Merge
        </button>
      </div>
      <div class="col-6">
        <button
          class="btn btn-primary btn-block"
          (click)="dupe['answer'] = 0; dupe['selection'] = 0"
        >
          Cancel
        </button>
      </div>
    </div>
    <div
      class="row"
      *ngIf="dupe['answer'] == 2 && dupe['resolved'] == false"
    >
      <div class="col-12">
        <div class="alert alert-primary" role="alert">
          <small>Are you sure those are two different persons? </small>
        </div>
      </div>
      <div class="col-6">
        <button
          class="btn btn-success btn-block"
          (click)="MarkAsDifferent(index)"
        >
          Yes
        </button>
      </div>
      <div class="col-6">
        <button
          class="btn btn-primary btn-block"
          (click)="dupe['answer'] = 0; dupe['selection'] = 0"
        >
          No
        </button>
      </div>
    </div>
  </div>
</div>
